export const COOKIE_CONSENT_DEFAULT_CONFIG = {
  pp_text:
    "To show videos, forms, and other interactive features, we use optional cookies. These are only set with your consent. You can change your preference at any time.",
  modal_details: {
    border_weight: 1,
    bg_color: "#ffffff",
    border_color: "#D1D5DB",
  },
  get link_details() {
    const url = window.__userPrivacyLink ||
      window?.objInit?.tlb?.company_privay_url ||
      window?.objInit?.profile?.privacy_link ||
      "https://kinetizine.com/privacy";
    return {
      link_text: "Privacy Notice.",
      link_url: url,
    };
  },
  value: {
    btn1_bg_color: "#ffffff",
    btn1_text_color: "#294561",
    btn1_border_color: "#A7B0BF",
    btn2_bg_color: "#294561",
    btn2_text_color: "#ffffff",
    btn2_border_color: "#294561",
  },
};

export const cloneCookieConsentDefaults = () =>
  JSON.parse(JSON.stringify(COOKIE_CONSENT_DEFAULT_CONFIG));
